import styled from '@style'

const Header = styled.header``

export { Header }
